import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState, memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFormNumerators } from 'system/pages/numerators/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersNumeratorProps {
  filterNumeratorsForm: FormikProps<FiltersFormNumerators>;
}

const FilterNumeratorsComponent = ({
  filterNumeratorsForm,
}: FiltersNumeratorProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-numerators-content"
        id="panel-numerators-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterNumeratorsForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Tipo Registro Numeratore"
                label="Tipo Registro Numeratore"
                id="numeratorRegisterType"
                name="numeratorRegisterType"
                fullWidth
                type="text"
                variant="outlined"
                value={filterNumeratorsForm.values.numeratorRegisterType}
                onChange={filterNumeratorsForm.handleChange}
                error={
                  filterNumeratorsForm.touched.numeratorRegisterType &&
                  Boolean(filterNumeratorsForm.errors.numeratorRegisterType)
                }
                helperText={filterNumeratorsForm.errors.numeratorRegisterType}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Descrizione numeratore"
                label="Descrizione numeratore"
                id="description"
                name="description"
                fullWidth
                type="text"
                variant="outlined"
                value={filterNumeratorsForm.values.description}
                onChange={filterNumeratorsForm.handleChange}
                error={
                  filterNumeratorsForm.touched.description &&
                  Boolean(filterNumeratorsForm.errors.description)
                }
                helperText={filterNumeratorsForm.errors.description}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Anno"
                label="Anno"
                id="year"
                name="year"
                fullWidth
                type="text"
                variant="outlined"
                value={filterNumeratorsForm.values.year}
                onChange={filterNumeratorsForm.handleChange}
                error={
                  filterNumeratorsForm.touched.year && Boolean(filterNumeratorsForm.errors.year)
                }
                helperText={filterNumeratorsForm.errors.year}
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterNumeratorsForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FilterNumeratorsComponent.displayName = 'Filters Numerators';

const FilterNumerators = memo(FilterNumeratorsComponent);

export default FilterNumerators;
